export default __webpack_public_path__ + "static/media/madame_detail15.027aaafe.jpg";